import { useState } from "react";
import { useToken } from "src/business-hooks/useToken";
import { parseModalSectionParam } from "src/components/general/ModalWithNavigation/ModalWithNavigation.utils";
import { useSearchParamState } from "src/hooks/useSearchParams";
import {
  SYSTEM_SETTINGS_SEARCH_PARAM,
  TOKEN_MANAGEMENT_SECTION,
} from "src/layout/Topbar/components/SystemSettings/SystemSettings.constants";
import { useQueryApiTokens } from "src/queries/auth/tokens.query";
import { TOKEN_EXPIRY_BANNER_DISMISS_KEY } from "./TokenExpiryBanner.constants";
import { dismissedKeyFor, getExpiringTokens } from "./TokenExpiryBanner.utils";

export const useTokenExpiryBanner = () => {
  const { loggedInUser } = useToken();
  // Read-only sessions are barred from /api/auth/tokens (403), so fetching
  // would only pop an error toast on every page load.
  const { data: tokens } = useQueryApiTokens({
    enabled: !!loggedInUser && !loggedInUser.read_only,
  });
  const [value, setValue] = useSearchParamState(SYSTEM_SETTINGS_SEARCH_PARAM);
  const [dismissedKey, setDismissedKey] = useState<string | null>(() =>
    sessionStorage.getItem(TOKEN_EXPIRY_BANNER_DISMISS_KEY)
  );

  const expiringTokens = getExpiringTokens(tokens);
  const currentKey = expiringTokens.length ? dismissedKeyFor(expiringTokens) : "";

  const visible = expiringTokens.length > 0 && dismissedKey !== currentKey;

  const hide = () => {
    setDismissedKey(currentKey);
    sessionStorage.setItem(TOKEN_EXPIRY_BANNER_DISMISS_KEY, currentKey);
  };

  const openTokenSettings = () => {
    if (parseModalSectionParam(value).isOpen) return;
    setValue(TOKEN_MANAGEMENT_SECTION);
  };

  return { expiringTokens, visible, hide, openTokenSettings };
};
